function handleTabEvent(event) {
  const clickedTab = event.currentTarget;
  const tabId = clickedTab.getAttribute("aria-controls");
  const targetPanel = document.getElementById(tabId);

  if (targetPanel) {
    const thisTabButtonList = clickedTab.closest("[role='tablist']");
    const thisTabPanelList = targetPanel.closest(".tab-panel-container");
    const allTabPanels = thisTabPanelList.querySelectorAll(".tab-panel");

    // Hide all tab panels
    allTabPanels.forEach((panel) => {
      panel.style.display = "none";
    });

    // Show the selected tab panel
    targetPanel.removeAttribute("style");

    // Update active state of tabs
    const allTabButtons = thisTabButtonList.querySelectorAll(
      ".tab-band-tab-button"
    );
    allTabButtons.forEach((button) => {
      button.classList.remove("active");
      button.setAttribute("aria-selected", "false");
    });
    clickedTab.classList.add("active");
    clickedTab.setAttribute("aria-selected", "true");
  }
}

(function ($, Drupal) {
  Drupal.behaviors.tabBand = {
    attach: function (context, settings) {
      $(document).ready(function () {
        $(".tab-band-tab-button").on("click keydown", function (event) {
          if (
            event.type === "click" ||
            (event.type === "keydown" &&
              (event.key === "Enter" || event.key === " "))
          ) {
            event.preventDefault();
            handleTabEvent(event);
          }
        });
      });
    },
  };
})(jQuery, Drupal);
